import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "@/components/Header";
import RateTicker from "@/components/RateTicker";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Ventures from "@/pages/Ventures";
import Careers from "@/pages/Careers";
import Overview from "@/pages/Overview";
import Leadership from "@/pages/Leadership";
import Investors from "@/pages/Investors";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import { useRate } from "@/hooks/useRate";
import { DTORBIT_URL } from "@/constants";

export { DTORBIT_URL };

function ScrollManager() {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (hash) {
            const timer = setTimeout(() => {
                document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
            }, 60);
            return () => clearTimeout(timer);
        }
        window.scrollTo(0, 0);
        return undefined;
    }, [pathname, hash]);
    return null;
}

export default function App() {
    const rate = useRate(30000);

    return (
        <BrowserRouter>
            <ScrollManager />
            <div
                className="min-h-screen bg-[#F6F9FF] text-[#0F1B3D] antialiased overflow-x-clip"
                data-testid="dtorbit-landing-page"
            >
                <Header />
                <RateTicker rate={rate} />
                <main>
                    <Routes>
                        <Route path="/" element={<Home rate={rate} />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/ventures" element={<Ventures />} />
                        <Route path="/careers" element={<Careers />} />
                        <Route path="/overview" element={<Overview />} />
                        <Route path="/leadership" element={<Leadership />} />
                        <Route path="/investors" element={<Investors />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/privacy" element={<Legal kind="privacy" />} />
                        <Route path="/terms" element={<Legal kind="terms" />} />
                        <Route path="/risk-disclosure" element={<Legal kind="risk" />} />
                        <Route path="*" element={<Home rate={rate} />} />
                    </Routes>
                </main>
                <Footer />
            </div>
        </BrowserRouter>
    );
}
